import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import Forms from '../../../Template/layoutComponents/Forms';
import { Button } from 'antd';

import useTemplateState from '../../../Template/atoms/variables.js';

import './style.css';
import { createNewComment, getComments } from '../../helpers/apiCalls.js';
import { useMsal } from '@azure/msal-react';
import Table from '../../../Template/layoutComponents/Table/index.jsx';
import { parseIsoDateString } from '../../../helpers/misc.js';

const CommentModal = ({ related_to, modelName }) => {
  const { t } = useTranslation();

  const { instance } = useMsal();
  const { setPendingApiCalls, setModalOpen, setModalContent, setModalStyle } = useTemplateState();

  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [forceReload, setForceReload] = useState(false);

  useEffect(() => {
    triggerApiCalls();
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['getComments']));
      const commentResponse = await getComments(instance, {
        modelName: modelName,
        related_to: related_to,
        limit: 10,
      });
      setComments(commentResponse);
    } catch (err) {
      console.log(err);
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'getComments'));
    }
  };

  return (
    <div className='comment-modal'>
      <Table
        handleSelect={null}
        handleRowClick={null}
        apiCall={async (instance, query) => {
          return await getComments(instance, {
            modelName: modelName,
            related_to: related_to,
            ...query,
          });
        }}
        items={comments.items}
        startingTotalItems={comments?.totalItems}
        tableSettings={{
          columnsConfig: {
            comment: {
              label: t('comment'),
            },
            made_by: {
              label: t('user'),
            },
            createdAt: {
              label: t('date'),
              customElement: (row) => {
                return parseIsoDateString(row.createdAt);
              },
            },
          },
          sortable: [],
          listFilter: [],
          searchFilter: [],
          uniqueValues: {},
        }}
        forceReload={forceReload}
        setForceReload={setForceReload}
      />
      <Forms
        id={'comment-modal'}
        inputs={[
          {
            name: 'New Comment',
            type: 'textarea',
            value: newComment,
            required: true,
            key: 'new_comment',
          },
        ]}
        onInputBlur={() => {}}
        onInputChange={(e) => {
          setNewComment(e.target.value);
        }}
      />
      <div className='comment-modal-buttons'>
        <Button
          className='cancel-btn'
          size='large'
          style={{
            color: '#242424',
            border: '1px solid #242424',
            backgroundColor: 'white',
          }}
          onClick={() => {
            setModalOpen(false);
            setModalContent(null);
            setModalStyle(null);
          }}
        >
          {t('cancel-btn')}
        </Button>

        <Button
          size='large'
          style={{
            color: 'white',
            border: '#1777ff',
            backgroundColor: '#1777ff',
            opacity: newComment.trim() ? 1 : 0.5,
          }}
          disabled={newComment.trim() ? false : true}
          onClick={async () => {
            try {
              setPendingApiCalls((current) => current.concat(['createNewComment']));
              await createNewComment(instance, {
                modelName: modelName,
                related_to: related_to,
                comment: newComment.trim(),
              });
              setNewComment('');
              setForceReload(true);
            } catch (err) {
              console.log(err);
            } finally {
              setPendingApiCalls((current) =>
                current.filter((item) => item !== 'createNewComment'),
              );
            }
          }}
        >
          {t('insert')}
        </Button>
      </div>
    </div>
  );
};

export default CommentModal;
